module.exports = __webpack_public_path__ + "img/icon-500.07e8aac0.svg";